import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'

import React from 'react'
import ReactDOM from 'react-dom'
import { Router, Redirect, Route, hashHistory } from 'react-router'
import { configure, autorun } from 'mobx'
import { sha1 } from 'object-hash/index'
import { initStore, sync } from './stores'
import { TABLE_VIEW } from './constants'

import App from './containers/App'

configure({ enforceActions: 'observed' })

// Calculate a unique key that is based on the HitList object
// that is being used to initialize the app.
const key = sha1(window.FlyBaseHitList)
const store = initStore(key)

// Sync the store w/ sessionStorage every 5000 ms on state change.
autorun(() => sync(store), { delay: 5000 })

// This causes a double loading effect.
//store.fetchPageItemsFromServer();

// Inject stores into Compnents rendered by the Router.
// https://github.com/ReactTraining/react-router/blob/master/docs/API.md#createelementcomponent-props
const createElement = (Component, props) => {
  return <Component store={store} {...props} />
}

// This callback is fired when a route is entered and it is declared via the onEnter prop.
const onEnter = (nextState, replace) => {
  //console.debug("onEnter called", nextState, replace);
  store.setCurrentPage(parseInt(nextState.params.page, 10))

  //console.log(nextState);
  // Set display mode if the page
  if (nextState.params.mode && nextState.params.mode === 'table') {
    store.setDisplayMode(TABLE_VIEW)
  }
  //store.fetchPageItemsFromServer();
}

const onChange = (prevState, nextState, replace) => {
  //console.debug("Setting page to " + nextState.params.page);
  store.setCurrentPage(parseInt(nextState.params.page, 10))
  //store.fetchPageItemsFromServer();
}

ReactDOM.render(
  <Router history={hashHistory} createElement={createElement}>
    <Route>
      <Route
        path="page/:page"
        component={App}
        onEnter={onEnter}
        onChange={onChange}
      />
      <Redirect from="/" to="page/1" />
    </Route>
  </Router>,
  document.getElementById('root')
)
